import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ExercisesComponent } from './exercises/exercises.component';
import { TopicComponent } from './topic/topic.component';
import { TeacherGuard } from '../App/teacher-guard.service';
import { TExercisesComponent } from './t-exercises/t-exercises.component';
import { TAllExercisesComponent } from './t-all-exercises/t-all-exercises.component';
import { TAllExamsComponent } from './t-all-exams/t-all-exams.component';
import { ExamComponent } from './exam/exam.component';
import { EvaluationComponent } from './evaluation/evaluation.component';
import { OpenQuestionComponent } from './open-question/open-question.component';
import { TExamComponent } from './t-exam/t-exam.component';
import { TOpenQuestionComponent } from './t-open-question/t-open-question.component';
import { MultipleChoiceComponent } from './multiple-choice/multiple-choice.component';
import { TMultipleChoiceComponent } from './t-multiple-choice/t-multiple-choice.component';

import { FindPathComponent } from './find-path/find-path.component';
import { TFindPathComponent } from './t-find-path/t-find-path.component';

import { FindSimplePathComponent} from './find-simple-path/find-simple-path.component';
import { TFindSimplePathComponent} from './t-find-simple-path/t-find-simple-path.component';

import { FindHamiltonComponent} from './find-hamilton/find-hamilton.component';
import { TFindHamiltonComponent} from './t-find-hamilton/t-find-hamilton.component';

import { FindSimplePathFixedLengthComponent } from './find-simple-path-fixed-length/find-simple-path-fixed-length.component'
import { TFindSimplePathFixedLengthComponent } from './t-find-simple-path-fixed-length/t-find-simple-path-fixed-length.component'

import {FindValidPathComponent} from './find-valid-path/find-valid-path.component';
import {TFindValidPathComponent} from './t-find-valid-path/t-find-valid-path.component';

const pathFindingRoutes: Routes = [
  {
    path: 'pathFinding', component: TopicComponent,
    children: [
      { path: '', component: ExercisesComponent, pathMatch: 'full' },
      { path: 'exam/:id', component: ExamComponent },
      { path: 'exam/:id/evaluation', component: EvaluationComponent },
      { path: 'exam/:examid/openQuestion/:id', component: OpenQuestionComponent },
      { path: 'exam/:examid/multipleChoice/:id', component: MultipleChoiceComponent },
      { path: 'openQuestion/:id', component: OpenQuestionComponent },
      { path: 'multipleChoice/:id', component: MultipleChoiceComponent },
      { path: 'findPath/:id', component: FindPathComponent },
      { path: 'findSimplePath/:id', component: FindSimplePathComponent},
      { path: 'findHamilton/:id', component: FindHamiltonComponent},
      { path: 'findSimplePathFixedLength/:id', component: FindSimplePathFixedLengthComponent},
      { path: 'findValidPath/:id', component: FindValidPathComponent},
      
      
      { path: 'exam/:examid/findPath/:id', component: FindPathComponent },
      { path: 'exam/:examid/findSimplePath/:id', component: FindSimplePathComponent},
      { path: 'exam/:examid/findHamilton/:id', component: FindHamiltonComponent},
      { path: 'exam/:examid/findSimplePathFixedLength/:id', component: FindSimplePathFixedLengthComponent},
      { path: 'exam/:examid/findValidPath/:id', component: FindValidPathComponent}
   
    ]
  },
  {
    path: 'teacher/pathFinding', canActivate: [TeacherGuard], canActivateChild: [TeacherGuard], component: TopicComponent,
    children: [
      { path: '', component: TExercisesComponent, pathMatch: 'full' },
      { path: 'openQuestion', component: TOpenQuestionComponent },
      { path: 'multipleChoice', component: TMultipleChoiceComponent },
      { path: 'openQuestion/:id', component: TOpenQuestionComponent },
      { path: 'multipleChoice/:id', component: TMultipleChoiceComponent },
      { path: 'allExercisesTeacher', component: TAllExercisesComponent },
      { path: 'allExamsTeacher', component: TAllExamsComponent },
      { path: 'findPath', component: TFindPathComponent },
      { path: 'findPath/:id', component: TFindPathComponent },
      { path: 'findSimplePath', component: TFindSimplePathComponent },
      { path: 'findSimplePath/:id', component: TFindSimplePathComponent },
      { path: 'findHamilton', component: TFindHamiltonComponent },
      { path: 'findHamilton/:id', component: TFindHamiltonComponent },
      { path: 'findSimplePathFixedLength', component: TFindSimplePathFixedLengthComponent},
      { path: 'findSimplePathFixedLength/:id', component: TFindSimplePathFixedLengthComponent},
      { path: 'findValidPath', component: TFindValidPathComponent},
      { path: 'findValidPath/:id', component: TFindValidPathComponent},

      

      { path: 'exam', component: TExamComponent },
      { path: 'exam/:examid', component: TExamComponent, pathMatch: 'full' },
      { path: 'exam/:examid/allExercisesTeacher', component: TAllExercisesComponent },
      { path: 'exam/:examid/openQuestion', component: TOpenQuestionComponent },
      { path: 'exam/:examid/openQuestion/:id', component: TOpenQuestionComponent },
      { path: 'exam/:examid/multipleChoice', component: TMultipleChoiceComponent },
      { path: 'exam/:examid/multipleChoice/:id', component: TMultipleChoiceComponent },

      { path: 'exam/:examid/findPath', component: TFindPathComponent},
      { path: 'exam/:examid/findPath/:id', component: TFindPathComponent},

      { path: 'exam/:examid/findSimplePath', component: TFindSimplePathComponent},
      { path: 'exam/:examid/findSimplePath/:id', component: TFindSimplePathComponent},
      
      { path: 'exam/:examid/findHamilton', component: TFindHamiltonComponent},
      { path: 'exam/:examid/findHamilton/:id', component: TFindHamiltonComponent},
     
      { path: 'exam/:examid/findSimplePathFixedLength', component: TFindSimplePathFixedLengthComponent},
      { path: 'exam/:examid/findSimplePathFixedLength/:id', component: TFindSimplePathFixedLengthComponent},

      { path: 'exam/:examid/findValidPath', component: TFindValidPathComponent},
      { path: 'exam/:examid/findValidPath/:id', component: TFindValidPathComponent},

    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(pathFindingRoutes)
  ],
  declarations: [],
  exports: [
    RouterModule]
})

export class TopicRoutingModule { }
